//
//
//
//
//
//
//

// 按需引入部分组件
import action from './action';

export default {
  name: 'index',
  props: ['params'],
  metaInfo: {
    title: '用户协议变更'
  },
  created: async function () {
    await this.getInfo();
  },
  data() {
    return {
      enterprise: this.params.enterpise || this.params.enterprise,
      isPlatform: this.params.is_platform == undefined ? 0 : this.params.is_platform,
      protocolType: this.params.protocol_type || 1,
      info: {}
    };
  },
  mounted() {
  },
  computed: {},
  filters: {},
  components: {},
  methods: {
    ...action
  }
};



// WEBPACK FOOTER //
// ./src/module/app/mergeAgreement/page.vue